import React from 'react';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay } from 'swiper/modules'; // Import Autoplay from swiper/modules
import { FaExternalLinkAlt } from 'react-icons/fa';
import { FaGithub } from 'react-icons/fa'
// import 'swiper/css'; // Import Swiper styles
// import 'swiper/css/autoplay'; // Import autoplay styles

function Projects() {
  return (
    <>
      <div className="Projects">
        <div className="Project">
          <div className="Project-display">
            <img src={process.env.PUBLIC_URL + '/Pictures/Todo App.png'} alt="Todo App" />
          </div>
          <div className="Project-description">
            <h2> Todo List </h2>
            <p>
              With its interactive interface, it allows users to add 
              activities they want to perform and remove them when they are 
              done. It also has a feature that allows users to edit 
              their entered activities if they made a mistake while 
              adding the activity.
            </p>
            <div className="Project-btn">
              <a href="https://activity-tracer.vercel.app/" target="_blank" rel="noopener noreferrer">
                <FaExternalLinkAlt />
                Live
              </a>
            </div>
          </div>
        </div>
      
        <div className="Project">
          <div className="Project-display">
            <img src={process.env.PUBLIC_URL + '/Pictures/Mathlete.png'} alt="Mathlete" />
          </div>
          <div className="Project-description">
            <h2> Mathlete </h2>
            <p> 
              I designed a web page similar to 
              <a href= "https://mathlete.pk/" target="_blank" rel="noreferrer"> https://mathlete.pk/ </a> 
              to practice html and css. This hepls me to seek knowledge 
              of different html tags  & css properties
            </p>
            <div className="Project-btn">
              <a href="https://github.com/Osama-Ali-arch/Mathelete" target="_blank" rel="noopener noreferrer">
                <FaGithub />
                Git
              </a>
            </div>
          </div>
        </div>

        <div className="Project">
          <div className="Project-display">
            <img src={process.env.PUBLIC_URL + '/Pictures/Figma.jpg'} alt=" Figma " />
          </div>
          <div className="Project-description">
            <h2> Figma to Pixel Perfect HTML and CSS </h2>
            <p> 
              Using Figma files has enhanced my ability to create pixel-perfect 
              HTML and CSS by allowing me to analyze and replicate designs 
              accurately. This practice has improved my precision in coding and 
              deepened my understanding of responsive techniques like media 
              queries, flexbox, and grid. Overall, Figma has been an invaluable 
              tool in my front-end development journey.
            </p>
            <div className="Project-btn">
              <a href="https://github.com/Osama-Ali-arch/Figma" target="_blank" rel="noopener noreferrer">
                <FaGithub />
                Git
              </a>
            </div>
          </div>
        </div>

        <div className="Project">
          <div className="Project-display">
            <img src={process.env.PUBLIC_URL + '/Pictures/Sign UP.png'} alt=" Sign Up" />
          </div>
          <div className="Project-description">
            <h2> User Authentication </h2>
            <p> 
              I develop a Sign-up, Login and forget password form with proper 
              checks to authenticate user. The sign-up login and forget password 
              form allow users to create account, login and forget password with 
              proper validation and error handling
            </p>
            <div className="Project-btn">
              <a href="https://github.com/Osama-Ali-arch/Login-Page" target="_blank" rel="noopener noreferrer">
                <FaGithub />
                Git
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Projects;
